import Icon from 'components/Icon';
import Text from 'components/Text';
import styled from 'styled-components/native';

export const Container = styled.View`
  margin-top: 8px;
  margin-bottom: 24px;
`;

export const Button = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
`;

export const ButtonContent = styled.View`
  width: 32px;
  height: 32px;

  background-color: ${props => props.theme.colors.grayscale.slot1};
  border-radius: 44px;
  box-shadow: 0px 4px 30px rgba(87, 85, 85, 0.2);

  justify-content: center;
  align-items: center;
`;

export const ButtonIcon = styled(Icon)`
  color: ${props => props.theme.colors.interaction.slot1};
`;

export const ButtonText = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 14px;

  margin-left: 12px;
`;
